module.exports = __webpack_public_path__ + "static/img/logo_27.f7526c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_27.png
// module id = FCZ9
// module chunks = 1